import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable, Observer } from 'rxjs';


export function EmptyOrBeginCMAB(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        const erroneo = (control.value !== '' && control.value.substr(0,5) !== 'CMAB-');
        return (erroneo?{CodReservaNoValido: true}:null);
    };
}

export function CodigoNoDuplicado(_InscripcionesS:any): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {

      return new Observable( (observer: Observer<ValidationErrors | null>) => {
          if (control.value === '') {
            observer.next(null);
            observer.complete();
            return;
          }
          _InscripcionesS.existeCodigoReserva(control.value).subscribe(
              (r:any) => {
                  observer.next(r?{CodigoDuplicado: true}:null);
                  observer.complete();
              }
          );

      });

  }
}
